import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/subscriptions.css';
//import Promise from 'promise-polyfill';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select';
import SpiffyCare from '../images/spiffy_care.png'
import WorkIcon from '../images/business.png'
import HomeIcon from '../images/home.png'
import Sedan from '../images/spiffysedan.svg'
import NonSedan from '../images/nonsedan.svg'
import SubscriptionService from '../utils/SubscriptionService.js';
import 'react-select/dist/react-select.css';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import Modal from 'react-modal';
import ErrorSnackBar from '../Components/ErrorSnackBar.js';

const override = css`
    display: block;
    margin: 10% 45%;
    border-color: red;
`;
class SubscriptionConfirmation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      width: document.body.clientWidth,
      color: null,
      errorMessage: '',
      open:false
    }
    this.SubscriptionService = new SubscriptionService()
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  returnToDashboard() {
    window.location.href = '../subscriptions';
  }
  saveSubscription() {
    this.setState({
      loading: true
    })
    this.SubscriptionService.saveSubscription(this.props.subscription.id, this.props.address.id, this.props.vehicle.id, this.props.startDate)
    .then(res =>{
          this.setState({
            loading:false,
            confirmationModalOpen: true
          })

    })
    .catch(err =>{
      this.setState({
        loading:false
      })
      this.props.setError("Cannot Save Subscription, please contact Spiffy")
    })
  }
  render(){
    const newCCStyles =
    this.state.width < 780 ?
    {
      content: {
        width: '98%',
        left:'1%',
        padding: '0px !important'
      }
    }:
      {
        content: {
          width: '50%',
          left:'25%',
          height: '65%',
          padding: '0px !important'
        }
      }
    var amount = parseFloat((this.props.subscription.subscription_vehicle_types[0].amount/100)).toFixed(2)
    var taxRate = parseFloat(this.props.address.tax_rate).toFixed(2)
    var total = (parseFloat(amount) + parseFloat(taxRate)).toFixed(2)
    return (
        <div>
          <div className="card">
            <div className="card-title gray-background text-center">
              <img width="25%" src={SpiffyCare}></img>
            </div>
            <div className="card-title bg-white">
              <div className="row align-items-center mb-2">
              <div className="col">
                <h6 className="card-subtitle ml-3">Location: {this.props.address.display_title}<br></br>{this.props.address.street}</h6>
              </div>
                <div className="col text-right mr-3">
                {(this.props.address.rdi == 'Residential') &&
                  <img className="icon" width="15%" src={HomeIcon}></img>}
                {(this.props.address.rdi != 'Residential') &&
                    <img className="icon" width="15%" src={WorkIcon}></img> }
                </div>
                </div>
            </div>
            <hr></hr>
            <div className="card-title bg-white">
              <div className="row align-items-center mb-2">
              <div className="col">
                <h6 className="card-subtitle ml-3">Vehicle: {this.props.vehicle.year} {this.props.vehicle.make} {this.props.vehicle.model}</h6>
              </div>
              <div className="col text-right mr-3">
              {(this.props.vehicle.vehicle_type.vtype == 'SEDAN') &&
                <img className="icon"  width="15%" src={Sedan}></img>}
              {(this.props.vehicle.vehicle_type.vtype != 'SEDAN') &&
                  <img className="icon" width="15%" src={NonSedan}></img> }
              </div>
                </div>
            </div>
            <hr></hr>
            <div className="card-title">
              <div className="card-title bg-white">
                <div className="row no-gutters align-items-center">
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Subscription</h6>
                  <h6 className="halfDiv textAlignRight2">{this.props.subscription.name}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Frequency</h6>
                  <h6 className="halfDiv textAlignRight2">{this.props.subscription.frequency}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Start Date</h6>
                  <h6 className="halfDiv textAlignRight2">{(this.props.startDate.getMonth()+1)+'/'+this.props.startDate.getDate()+'/'+this.props.startDate.getFullYear()}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Base Amount</h6>
                  <h6 className="halfDiv textAlignRight2">${amount}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Tax Amount</h6>
                  <h6 className="halfDiv textAlignRight2">${taxRate}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Total</h6>
                  <h6 className="halfDiv textAlignRight2">${total}</h6>
                </div>
              </div>
                <hr></hr>
                <div className="card-title text-center mt-2 mb-0">
                <p>Confirming will charge your default card and begin generating appointments. Your card will be charge monthly on the same day</p>
                <button className="btn newApptButton" onClick = {() => this.saveSubscription()}>Confirm</button>
              </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={this.state.loading}
            contentLabel="Example Modal"
            style={newCCStyles}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Loading</h4>
            </div>
            <div className="topDiv">
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={100}
                color={'#164070'}
                loading={this.state.loading}
              />
            </div>
          </Modal>
          <Modal
            isOpen={this.state.confirmationModalOpen}
            contentLabel="Example Modal"
            style={newCCStyles}
            >
            <div className="card-header blue-background text-white text-center dateTimeContainer ">
              <h4>Confirmation</h4>
            </div>
            <div className="topDiv">
              <p>Your subscription has been confirmed</p>
              <button className="btn btn-primary promoAdd" onClick={() => this.returnToDashboard()}>Close</button>
            </div>
          </Modal>
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
        </div>

              )
    }
}
export default SubscriptionConfirmation;



// WEBPACK FOOTER //
// ./src/Components/SubscriptionConfirmation.js